import { IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { EServiceType } from '../../../../types/reducers/publishTerms';

export const getServiceName = (serviceName: IRecommendedPackageService['serviceType']): string => {
  switch (serviceName) {
    case EServiceType.Free:
      return 'Публикации';
    case EServiceType.Paid:
      return 'Публикации';
    case EServiceType.Premium:
      return 'Премиум';
    case EServiceType.Calltracking:
      return 'Защита номера';
    case EServiceType.Auction:
      return 'Баллы';
    case EServiceType.Top3:
      return 'Топ';

    default:
      return '';
  }
};
